import React from 'react';
import { Button, Breadcrumb, Popover } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import HandleGeo from './HandleGeo';
import queryString from 'query-string';

export class CreateGeo extends React.Component {
    constructor(props) {
        super(props);
        let params = queryString.parse(this.props.location.search);
        this.state = {
            user: this.props.token,
            geos: [0],
            id: 0,
            geoSaved: false,
            geoEdit: params.id
        };

        this.addGeo = this.addGeo.bind(this);
        this.callbackGeoSaved = this.callbackGeoSaved.bind(this);

        if (this.props.isEdit) {
            document.title = "Polar - Edit Places"
        } else {
            document.title = "Polar - Create Places"
        }
    }

    addGeo() {
        window.location.reload()
    }

    loadCreate() {
        window.location = '/places/create'
    }

    callbackGeoSaved = (childData) => {
        this.setState({ geoSaved: childData })
    }

    goBack() {
        return window.open("/places/index", '_self');
    }

    render() {

        let addNewGeo = this.props.isEdit ?
            <Button style={{ position: 'relative', top: '15px' }} onClick={this.loadCreate}>Add new Place</Button>
            : this.state.geoSaved ?
                <Button style={{ position: 'relative', top: '15px' }} onClick={this.addGeo}>Add new Place</Button>
                :
                <Popover content="You need to save the prior Place in order to add a new one">
                    <Button disabled style={{ position: 'relative', top: '15px' }} onClick={this.addGeo}>Add new Place</Button>
                </Popover>

        let title = this.props.isEdit ? 'Edit Place' : 'Create Place'

        return (
            <Container fluid={true}>
                <Row>
                    <Col sm="12" style={{ display: 'inline-flex' }}>
                        <Button className="backButt" icon="caret-left" onClick={this.goBack}></Button>
                        <Breadcrumb className="bread">                            
                            <Breadcrumb.Item>{title}</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>

                    <Row style={{ width: '100%' }}>
                        <Col style={{ minHeight: '50vh' }} sm='12'>
                            <div className="wizardFields wizardContacts" style={{ minHeight: '50vh' }}>
                                <div className="wizardBackground" style={{ height: 'inherit', textAlign: 'center' }}>
                                    <Row>
                                        {this.state.geos.map(i =>
                                            <HandleGeo isEdit={this.props.isEdit} geoEditId={this.state.geoEdit} parentCallbackGeoSaved={this.callbackGeoSaved} token={this.state.user} key={i} />
                                        )}
                                    </Row>
                                    {addNewGeo}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Row>
            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/GeoRegion/CreateGeo.js